import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { CustomerSearchModel } from '../../Models/Models/Customer/CustomerSearch/CustomerSearchModel';
import { IJsonDate } from '../../System/IJsonDate';

declare var IS_RUNNING_IN_APP_POOL;

export class CustomerMatchingClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(firstName: string, lastName: string, dateOfBirth: IJsonDate, visibleToAdviserId: number, pageIndex: number, pageSize: number): Promise<CustomerSearchModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/CustomerMatching/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { firstName: firstName, lastName: lastName, dateOfBirth: dateOfBirth, visibleToAdviserId: visibleToAdviserId, pageIndex: pageIndex, pageSize: pageSize }

    return AjaxWrapper.get<CustomerSearchModel, any>(url, data);
  }
}

